<template>
  <a
    :ref="(el: Element | ComponentPublicInstance | null) => props.menuRef?.(el as Element | null)"
    :class="menuItemClasses"
    @click.stop.prevent="handleClick"
    @mouseenter="handleMouseEnter"
    @mouseleave="handleMouseLeave"
    data-navbar-element
  >
    <div class="relative inline-block pb-1">
      <PContent class="font-bold text-dark text-center">
        {{ menuItem.name }}
      </PContent>

      <!-- Soulignement progressif -->
      <div 
        :class="underlineClasses"
        :style="underlineStyle"
        class="absolute rounded-4xl bottom-0 left-0 h-1 transition-all duration-300"
      />
    </div>
  </a>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import type { ComponentPublicInstance } from 'vue'
import PContent from '@/components/atoms/text/PContent.vue'
import { cn } from '@/lib/utils'
import type { MenuItem as MenuItemType } from '../types/navigation'

interface Props {
  menuItem: MenuItemType
  isActive: boolean
  menuRef?: (el: Element | ComponentPublicInstance | null) => void
}

const props = defineProps<Props>()

const emit = defineEmits<{
  menuClick: [menuItem: MenuItemType]
  menuHover: [menuItem: MenuItemType]
  menuLeave: []
}>()

const isHovered = ref(false)
const showUnderline = computed(() => isHovered.value || props.isActive)

const menuItemClasses = computed(() => 
  cn(
    'relative w-1/5 h-full flex flex-col items-center justify-center cursor-pointer px-4 py-2 rounded-lg font-medium transition-all duration-300',
    props.isActive 
      ? 'bg-blue-100 text-primary font-bold' 
      : 'text-gray-700 hover:text-primary font-bold'
  )
)

const underlineClasses = computed(() => 
  cn(
    'w-full'
  )
)

const underlineStyle = computed(() => ({
  backgroundColor: '#07A766',
  transform: `translateY(50%) scaleX(${showUnderline.value ? 1 : 0})`,
  transformOrigin: 'left'
}))

const handleClick = () => {
  emit('menuClick', props.menuItem)
}

const handleMouseEnter = () => {
  isHovered.value = true
  emit('menuHover', props.menuItem)
}

const handleMouseLeave = () => {
  isHovered.value = false
  emit('menuLeave')
}
</script>

<style scoped>
/* Styles additionnels si nécessaire */
</style>

